import { createSelector } from 'reselect';
import get from 'lodash/get';

export const getDimensions = state => state.dimensions;

export const getDimensionWidth = createSelector(getDimensions, data => get(data, 'width'));



// WEBPACK FOOTER //
// ./src/reducers/dimensions/selectors.js